import { Box, Typography, Link } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

export default function DailyCreditsAlert() {
    return (
        <Box
            sx={{
                bgcolor: "#fff8ec",
                border: "1px dashed #ccc",
                borderRadius: 2,
                p: 6,
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                maxWidth: 800,
                height: 360,
                mx: "auto",
                mt: -2,
                gap:0
            }}
        >
            <WarningAmberIcon
                sx={{ fontSize: 64, color: "#FF9800", mb: 2 }}
            />
            <Typography
                sx={{
                    fontFamily: '"Open Sans", sans-serif',
                    fontWeight: 600,
                    fontStyle: 'normal',
                    fontSize: '20px !important',
                    lineHeight: '20px',
                    letterSpacing: '0px',
                    textAlign: 'center',
                    color: '#333',
                    mb: 0,
                }}
            >
                You’ve used up your daily credits.
                <br />
                Your daily allowance will reset at midnight.
                <br />
                You can still write comments manually.
            </Typography>


            {/* <Typography
                sx={{
                    display: "block",
                    mt: 3,
                    fontFamily: '"Source Sans Pro", sans-serif',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontSize: '12px !important',
                    lineHeight: '100%',
                    letterSpacing: '0.5px',
                    textAlign: 'center',
                    textTransform: 'uppercase',
                    color: '#2f6ed6',
                    "&:hover": { textDecoration: "underline" },
                }}
            >
                Contact support to buy more credits
            </Typography> */}

        </Box>
    );
}
